import { Button } from "@nxtvid/component-library"
import './stripeOnboardingComplete.css';

const StripeOnboardingComplete = () =>{
    return(
        <div className="stripe-onboarding-completed-message">
            <h2>Stripe Onboarding Completed</h2>
            <p>Your Stripe onboarding is complete! You can now receive payments for your projects.</p>
            <Button size='medium' type='primary' label='Go Back to Inbox' onClick={()=>window.location.href = '/Inbox'}/>
        </div>
    )
}

export default StripeOnboardingComplete;